import React from 'react';
import PropTypes from 'prop-types';
import { formatMoney, formatNumber } from 'utils/formatting';
import { precisionRound } from 'utils/math';
import CurrencyCardNew from './CurrencyCardNew';
import DollarIcon from './assets/DollarsIcon.png';
import TicketIcon from './assets/MaroonTicketIcon.png';

const getCasinoCurrencyCards = casinoCurrencies =>
  casinoCurrencies.map(({ label, amount, format, icon }) => (
    <CurrencyCardNew
      key={label}
      amount={amount}
      label={label}
      format={format}
      icon={icon}
    />
  ));

export const CmpCurrencyPanelNew = ({ statusData }) => {
  const cmpPlayerStatus = statusData?.statusV2?.cmpPlayerStatus;
  const freePlay =
    cmpPlayerStatus && precisionRound(cmpPlayerStatus.freePlay, 2) * 100;
  const pointsBalance = cmpPlayerStatus?.basePoints;
  const drawings = cmpPlayerStatus?.drawings;
  const totalDrawingTickets =
    drawings?.reduce((total, drawing) => total + drawing.amount, 0) || 0;

  const casinoCurrencies = [
    {
      amount: pointsBalance,
      label: 'Points Balance',
      format: formatNumber
    },
    {
      amount: freePlay,
      label: 'Free Play',
      format: formatMoney,
      icon: DollarIcon
    },
    {
      amount: totalDrawingTickets,
      label: 'Casino Drawings',
      format: formatNumber,
      icon: TicketIcon
    }
  ];

  return (
    <div className="currency-cards">
      {getCasinoCurrencyCards(casinoCurrencies)}
    </div>
  );
};

CmpCurrencyPanelNew.propTypes = {
  statusData: PropTypes.shape({
    statusV2: PropTypes.shape({
      cmpPlayerStatus: PropTypes.shape({
        freePlay: PropTypes.number,
        basePoints: PropTypes.number,
        drawings: PropTypes.arrayOf(
          PropTypes.shape({
            amount: PropTypes.number
          })
        )
      })
    })
  })
};

export const PlsCurrencyPanelNew = ({ statusData }) => {
  const { pointsBalance, freePlay } =
    statusData?.statusV2?.plsPlayerStatus || {};

  const casinoCurrencies = [
    {
      amount: pointsBalance,
      label: 'Points Balance',
      format: formatNumber
    },
    {
      amount: freePlay,
      label: 'Free Play',
      icon: DollarIcon
    }
  ];

  return (
    <div className="currency-cards">
      {getCasinoCurrencyCards(casinoCurrencies)}
    </div>
  );
};

PlsCurrencyPanelNew.propTypes = {
  statusData: PropTypes.shape({
    statusV2: PropTypes.shape({
      plsPlayerStatus: PropTypes.shape({
        freePlay: PropTypes.string,
        pointsBalance: PropTypes.number
      })
    })
  })
};
